module.exports = __webpack_public_path__ + "static/AltDinner17-0495bd1c7a0a32258ec228892f712a62.jpg";